import { useMutation } from '@tanstack/react-query';

import { organizationServices } from '../../index';

export const useVerifySignUp = () =>
  useMutation(({ verificationCode, verificationToken }) =>
    organizationServices.verifySignUp(verificationCode, verificationToken)
  );
